import React, { useContext, useEffect } from "react";
import { PageTitle } from "../../../_metronic/layout/core";
import { SaleEntryStep1Form } from "./SaleEntryStep1Form";
import BedRockContext from "../../BedRockContext";

export function SaleEntryStep1Page() {
    const myData = useContext(BedRockContext);

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Sales",
            path: "/sales-list",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>New Sale - Vehicle Entry (Step 1)</PageTitle>
            <SaleEntryStep1Form />
        </>
    );
}
